<template>
  <transition name="ae-fade">
    <div class="custom-overlays-indication">
      <span class="warning"
        >** Visual effects included in this preset may be hidden **</span
      >
      <div class="more-info">
        <span
          >Please remove other effects to get the most out of this preset.</span
        >
        <a href="#" @click="$_openSupport">Learn how</a>
      </div>
    </div>
  </transition>
</template>

<script>
import app from 'app';

export default {
  name: 'custom-overlays-indication',

  methods: {
    $_openSupport() {
      app.openSupportTab({
        // @NOTE: seem like link is dead, waiting for the new link from @Moran
        path: 'effect-text-overlay-combinations',
      });
    },
  },
};
</script>
